// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__U9xEe","input":"styles_input__YiuwY","btn_submit":"styles_btn_submit__2RTjf"};